const Footer = () => {
    return(
        <footer>
            <p> &copy; 2021 by <a href="https://grantvanb.ca">Grant van Boeschoten</a></p>
        </footer>
    )
}

export default Footer;